import * as styles from "./AlertDialogDescription.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { AlertDialog as BaseAlertDialog } from "@base-ui/react/alert-dialog";

import type { AlertDialogDescriptionProps } from "./AlertDialog.types";

export function AlertDialogDescription({
  className,
  ...props
}: AlertDialogDescriptionProps): JSX.Element {
  return (
    <BaseAlertDialog.Description
      data-slot="alert-dialog-description"
      className={clsx(styles.description, className)}
      {...props}
    />
  );
}
